import io from 'socket.io-client';

var socket = io(process.env.REACT_APP_WEBSOCKET_SERVER, {
  // WARNING: in that case, there is no fallback to long-polling
  transports: [ 'websocket' ]
  // transports: [ 'websocket', 'polling' ]
});
export default socket
